import { ResponseError } from './ResponseError';
import { Paging } from './common/paging';

export interface ResponseBase<T> {
    totalCount: number; 
    pageNo?:number; 
    pageSize?:number;
    resourceList: Array<T>;
    data?: T; 
    error?: ResponseError;  
    isSuccess: boolean;   
}

export interface RequestBase extends Paging { }

export const defaultResponse = { //}= <T>(defaultValue: T): ResponseBase<T> => ({
    totalCount: 0, 
    resourceList: [], 
    isSuccess: false,
};

export interface DashboardBase<T> {
    dataDate: Date; 
    totalCount: number; 
    dataSet?: Array<T>; 
}

export const defaultDashbardResponse = {
    dataDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)), 
    totalCount: 0,
}
